import { Button, Text } from "native-base";
import React from "react";

type BadgeProps = {
  label: string;
  active: boolean;
  onSelect: () => void;
};

const Badge = ({ label, active, onSelect }: BadgeProps) => {
  return (
    <Button
      variant="outline"
      size="sm"
      mx="1"
      borderRadius="full"
      bgColor={active ? "secondary.400" : "white.50"}
      _hover={{
        bgColor: active ? "secondary.100" : "primary.50",
      }}
      onPress={onSelect}>
      <Text color="primary.600" bold>
        {label}
      </Text>
    </Button>
  );
};

export default Badge;
